import React, { PureComponent } from 'react';
import { bool, string, number, oneOfType, node } from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classnames from 'classnames';
import Input from 'components/common/Input';
import { FontIcon } from 'homecredit-ui';
import { ICON } from './constant';

import s from './Collapse.css';

class Collapse extends PureComponent {
  static propTypes = {
    // Event handler props
    // Props setting
    value: oneOfType([number, string]),
    name: string,
    className: string,
    placeholder: string,
    errorMsg: string,
    disabled: bool,
    multiple: bool,
    required: bool,
    filterable: bool,
    touched: bool,
    children: node,
    classNameWrapperOptions: string,
    visible: bool,
    // Props text
    icon: string,
  };

  static defaultProps = {
    // Event props
    // Props setting
    value: undefined,
    name: undefined,
    className: '',
    placeholder: '',
    errorMsg: '',
    disabled: false,
    multiple: false,
    required: false,
    filterable: false,
    touched: false,
    children: null,
    classNameWrapperOptions: '',
    icon: 'keyboard_arrow_down',
    visible: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      visible: props.visible,
    };

    this.root = React.createRef();
    this.input = React.createRef();
  }

  /**
   * @function handleInputClick
   * This func will handle every user click to select's input
   * @return {type} {description}
   */
  handleInputClick = e => {
    e.preventDefault();
    const { target } = e;
    const { disabled, filterable } = this.props;
    const { visible } = this.state;

    if (disabled) return;

    // If filterable is disable
    if (!filterable) {
      this.toggleOptionsWrapper();
      return;
    }

    // If options not open
    if (!visible) {
      target.select();
      this.setState({
        visible: true,
      });
      return;
    }

    // If options open
    if (target === document.activeElement) {
      target.blur();
      this.setState({
        visible: false,
      });
    } else {
      target.select();
    }
  };

  toggleOptionsWrapper = () => {
    this.setState(preState => ({
      visible: !preState.visible,
    }));
  };

  render() {
    const {
      placeholder,
      multiple,
      filterable,
      name,
      className,
      classNameWrapperOptions,
      required,
      errorMsg,
      touched,
      icon,
      children,
      value,
    } = this.props;
    const { visible } = this.state;

    return (
      <div className={classnames(s.select, className)} ref={this.root}>
        <div className={s.selectInputWrapper}>
          <Input
            value={value}
            className={classnames(s.selectInput, className)}
            readOnly={!filterable || multiple}
            onMouseDown={this.handleInputClick}
            required={required}
            name={name}
            id={name}
            ref={this.input}
            label={placeholder}
            errorMsg={errorMsg}
            touched={touched}
            autoComplete={false}
          />
          <FontIcon className={s.selectIconDropdown}>
            <span>{icon || ICON[+visible]}</span>
          </FontIcon>
        </div>
        {visible && (
          <div className={classnames(classNameWrapperOptions)}>{children}</div>
        )}
      </div>
    );
  }
}

export default withStyles(s)(Collapse);
